import Cookies from 'cookies-js';

// const instance = new Cookies();

export default Cookies
